import type { Settings } from '../../context/settingsContext';
import type { Theme } from '@mui/material/styles';

const Menu = (settings: Settings) => {
  const boxShadow = (theme: Theme) => {
    if (settings.skin === 'bordered') {
      return theme.shadows[0];
    } else if (theme.palette.mode === 'light') {
      return theme.shadows[8];
    } else return theme.shadows[9];
  };

  return {
    MuiMenu: {
      styleOverrides: {
        root: (theme: { theme: Theme }) => ({
          '& .MuiListSubheader-root': {
            backgroundColor: theme.theme.palette.background.menu,
          },
          '& .MuiMenu-paper': {
            backgroundColor: theme.theme.palette.background.menu,
            backdropFilter: theme.theme.palette.background.filter,
            borderRadius: 5,
            boxShadow: boxShadow(theme.theme),
            ...(settings.skin === 'bordered' && {
              border: `1px solid ${theme.theme.palette.divider}`,
            }),
          },
          '& .MuiButtonBase-root.MuiMenuItem-root .MuiListItemIcon-root': {
            width: '25px',
            minWidth: '25px',
          },
        }),
      },
    },
  };
};

export default Menu;
